export const taskStorageName: string = 'gabrielogregorio-my-daily/tasks';
export const weightStorageName: string = 'gabrielogregorio-my-daily/weight ';
